export default __webpack_public_path__ + "static/media/matchPurple.35ee925c.svg";